import { isIOS, isMobile, isWindows, isMacOs } from 'react-device-detect';

import { POST_LOGIN_DOWNLOAD_PROMPT_KEY, PWA_INSTALLED_KEY } from './constants';

export const getPromptShownCount = () => {
  return localStorage.getItem(POST_LOGIN_DOWNLOAD_PROMPT_KEY) ?? '0';
};

export const getInstalledValue = () => {
  return localStorage.getItem(PWA_INSTALLED_KEY);
};

export const getDeviceType = () => {
  if (isIOS) {
    return 'IOS';
  } else if (isMobile) {
    return 'Android';
  } else if (isWindows || isMacOs) {
    return 'Desktop/Laptop';
  } else {
    return '';
  }
};
